/**
 * Word (.docx) export jedálneho lístka — klient pripraví podklady z AKTUÁLNEHO menu
 * (rovnaké ako PDF: buildWeekFromMenu → days), pošle ich na backend, ktorý vygeneruje
 * .docx (logo načíta server bez CORS) a vráti súbor na stiahnutie.
 *
 * Pozn.: generovanie je na backende kvôli kompatibilite (docx v9 nejde skompilovať cez CRA/babel).
 */
import { generateDailyMenuDocx } from "app/services/api/dailyMenu";

/** Krátky nadpis podľa typu menu (ako vo vzore „OBEDY"). Fallback = veľké písmená sheet titulu. */
function menuTitle(menuType, sheetTitle) {
  const map = {
    lunch: "OBEDY",
    breakfast: "RAŇAJKY",
    dinner: "VEČERE",
    night: "NOČNÉ MENU",
  };
  if (map[menuType]) return map[menuType];
  return String(sheetTitle || "DENNÉ MENU").toUpperCase();
}

/** Stiahne Blob ako súbor. */
function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/**
 * Vygeneruje (na backende) a stiahne jedálny lístok ako .docx.
 * @param {object} p
 * @param {{name,date,soups,items}[]} p.days - z buildWeekFromMenu
 * @param {string} p.menuType
 * @param {string} p.sheetTitle - sheetTitleForMenuType(menuType)
 * @param {string} [p.brandName]
 * @param {string} [p.logoUrl]
 * @param {object} [p.copy] - DEFAULT_PRINT_COPY_SK
 * @param {string} [p.filename]
 * @returns {Promise<void>}
 */
export async function downloadDailyMenuDocx({
  days,
  menuType,
  sheetTitle,
  brandName,
  logoUrl,
  copy,
  filename,
}) {
  const blob = await generateDailyMenuDocx({
    days: Array.isArray(days) ? days : [],
    title: menuTitle(menuType, sheetTitle),
    brandName: brandName || "",
    logoUrl: logoUrl || "",
    copy: copy || {},
  });
  downloadBlob(blob, filename || "jedalny-listok.docx");
}
